import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { TabsPanel } from 'ui';
import { EntitiesTable } from 'modules/common';
import { searchEntitiesAction } from 'store/searchResult/searchResultActions';
import { ratingTypes } from 'shared/constants/ratingTypes';
import { getSortedFilterableIndustries } from 'selectors/common';

export const RatingCoverageRelated = () => {
  const { t } = useTranslation();
  const entities = useSelector(
    ({ searchResult }) => searchResult.entities.byRatingType[ratingTypes.CREDIT_RATING],
  );
  const relatedEntities = useSelector(({ shared }) => shared.relatedEntities);
  const filterableIndustries = useSelector(getSortedFilterableIndustries);
  const relatedEntitiesIds = relatedEntities.data.map(({ id }) => id);

  const isEmpty = !relatedEntities.isPending && relatedEntities.data.length === 0;

  if (isEmpty) return <Navigate to={{ pathname: '/not-found' }} />;

  return (
    <>
      <Box mb={2}>
        <Typography variant="h5">{t('Your selected entities')}</Typography>
      </Box>
      <TabsPanel active="entities">
        <div label={t('Entities')} counter={entities.total} value="entities">
          {!relatedEntities.isPending && (
            <EntitiesTable
              dataSelector={entities}
              actionCreator={searchEntitiesAction}
              constantFilter={{
                issuerIds: relatedEntitiesIds,
              }}
              filterableIndustries={filterableIndustries}
            />
          )}
        </div>
      </TabsPanel>
    </>
  );
};
